import { Radio, RadioProps } from "@mui/material";
import { ReactComponent as RadioIcon } from "../../icons/Radio.svg";
import { ReactComponent as RadioSelectedIcon } from "../../icons/RadioSelected.svg";

export default ({ ...otherProps }: RadioProps) => {
  return (
    <Radio
      icon={<RadioIcon width="20px" />}
      checkedIcon={<RadioSelectedIcon width="20px" />}
      sx={{}}
      {...otherProps}
    />
  );
};
